<template>
  <div>
    <main>
      <div class="w mian_content">

        <div class="about_content">
          <div class="case_r">

            <!-- 标题 -->
            <div class="about_t">
              {{list.content.title}}

              <div class="case_data">
                发布日期：{{list.content.create_time}}
              </div>
            </div>

            <!-- <div class="case_con">
                    {{list.content.about}}
            </div> -->
          </div>

          <!-- 文章内容 -->
          <div class="about_news" v-html="list.content.content">
          </div>

        </div>

        <div class="content_footer">
          <div class="fl" @click="newsup" v-if="list.content.uptitle.length">
            上一篇：{{list.content.uptitle}}
          </div>
          <div class="fl" v-else="list.content.uptitle.length">
            上一篇：没有了
          </div>

          <div class="fr" @click="newsdown" v-if="list.content.downtitle.length">
            下一篇：{{list.content.downtitle}}
          </div>
          <div class="fr" v-else>
            下一篇：没有了
          </div>
        </div>

      </div>

    </main>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: {
          newprograma: '详情页',
          content: {
            id: '2',
            title: "",
            intro: "",
            content: '',
            create_time: '',
            uptitle: '',
            upId:'',
            downtitle: '',
            downId:''
          },
        },
      }
    },
    methods: {
      newsup() {
        this.getcase(this.list.content.upId)
      },
      newsdown() {
        this.getcase(this.list.content.downId)
      },
      async getcase(val) {
        var dt = await this.$axios.post('/api/itemnewscut', {
          case: val,
          state:0
        })
        dt.data = JSON.parse(dt.data)
        if (dt.status == 200) {
          if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.list.content = dt.data.data
        this.$router.push({
          name: 'news', params: {
            id: val + '.html',
          }
        })
      }
    },
    created() {
      this.list.content.id = this.$route.params.id.split('.')[0]
      this.getcase(this.list.content.id)
    },
    watch: {
      $route(to, from) {
        this.getcase(this.$route.params.id.split('.')[0])
      }
    }
  }
</script>

<style lang="less" scoped>
  main {
  }

  .mian_content {
    margin: 40px auto;
    background: #fff;
    overflow: hidden;
    box-shadow: 1px 1px 18px 2px #f2f2f2;

    .case_data {
      color: #666;
      font-size: 14px;
      line-height: 30px;
      padding-bottom: 16px;
      padding-top: 12px;
      text-align: center
    }

  }


  /* 文章内容 */
  .about_content {
    padding: 20px;
    overflow: hidden;

    .about_t {
      text-align: center;
      font-size: 35px;
      color: #323232;
      font-weight: normal;
      position: relative;
      padding: 15px 0 0px;
      border-bottom: 1px dotted #d9d9d9;
    }

    .about_new {
      color: #6d7276;
      font-size: 16px;
      line-height: 28px;
      margin-bottom: 24px;
    }

    .about_news {
      overflow: hidden;
      padding: 20px 25px;
      min-height: 200px;
      line-height: 50px;

      img {
        max-width: 99%;
        margin: 10px auto;
        display: block
      }
    }


    /* 头部例3*/

    .case_con {
      color: #666;
      font-size: 16px;
      line-height: 30px;
      padding-bottom: 16px;
      padding-top: 12px;
      border-bottom: 1px dotted #d9d9d9;
    }

  }

  /* 底部翻页 */
  .content_footer {
    border-top: 1px dotted #999;
    margin-top: 30px;
    margin:0 4%;
    padding: 30px 0;
    color: #999;
    overflow: hidden;

  }

  /* 内容页图片滑动 */
  .wrapper_news {
    border-radius: 5px;
    overflow: hidden;
    width: 70%;
    margin: 20px auto;


    .swiper-img {
      width: 100%;
      min-height: 160px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/news.vue